import styled from "styled-components";
import { isPeaks } from "../../platform/identifiers";
import { isMobileDevice } from "../../components/AlmeUtilities/device-utils";
const topRight = `
    top: 110px;
    right: 16px;
`;
const topLeft = `
    top: 110px;
    left: 16px;
`;
const bottomRight = `
    bottom: 110px;
    right: 16px;
`;
const bottomLeft = `
    bottom: 110px;
    left: 16px;
`;
const getChatIconPlacementStyles = (position) => {
    switch (position) {
        case "BottomLeft":
            return bottomLeft;
        case "BottomRight":
            return bottomRight;
        case "TopLeft":
            return topLeft;
        case "TopRight":
            return topRight;
    }
};
const getChatIconPosition = (position) => {
    const testPageRoot = document.getElementById("alme-ui-test-page-root");
    if (isPeaks() && !testPageRoot) {
        return isMobileDevice() ? `top: 64px; right:16px;` : `top: 92px; right:16px;`;
    }
    else {
        return getChatIconPlacementStyles(position);
    }
};
export const LaunchIconBtn = styled.button `
    border: none;
    position: fixed;
    z-index: ${props => props.zIndex};
    ${(props) => getChatIconPosition(props.chatIconPosition)}
    width: 50px;
    height: 50px;
    border-radius: 50%;
    padding:0;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12);
    &:focus {
        box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.3), 0px 5px 8px 0px rgba(0,0,0,0.3), 0px 1px 14px 0px rgba(0,0,0,0.2);
    }
`;
